import { Dispatch, SetStateAction, useRef, useState } from "react";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import StickyToolbar from "../../../Components/StickyToolbar";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { useModuloInfo } from "../../../Context/ModuloInfo";
import Table from "../../../Components/Table";
import { ColumnDescription } from "react-bootstrap-table-next";
// import { faEdit } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, OverlayTrigger, ProgressBar, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { formatedTelefone, formatMoneyReais } from "../../../Tools/FormatTools";
import FilterGestaoLeads from "./FilterGestaoLeads/FilterGestaoLeads";
import {
    ExportarExcelCasosVendasController,
    ListarCasosVendasController,
    ListarEtapasVendasController,
} from "../../../Controllers/Vendas/Caso/CasoController";
import {
    IListarCasoRequest,
    IListarCasoResponse,
} from "../../../Interfaces/Vendas/Caso/CasoInterface";
import moment from "moment";
import { ACESSOS } from "../../../Routes/Acessos";
import {
    faBars,
    faChartBar,
    faCheckSquare,
    faCircle,
    faCommentDots,
    faEdit,
    faEnvelope,
    faExchangeAlt,
    faFunnelDollar,
    faGlobe,
    faHashtag,
    faHistory,
    faHome,
    faPlus,
    faSearch,
    faThermometerHalf,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HistoricoCardPage from "../../../Components/CardsPages/Historico";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import CasoAtividade from "../../../Components/CardsPages/HistoricoClienteCobranca/ComponenteHistorico/CasoAtividade";
import CadastrarHistorico from "../../../Components/CardsPages/HistoricoClienteCobranca/CadastrarHistorico";
import { EnviarEmail } from "../../Cobranca/Atendimento/ModalEnviarEmail";
import CadastrarVisita from "../GestaoDeVisitas/CadastrarVisita";
import { IPropsTableChange } from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import CopyToClipboard from "../../../Components/Utils/CopyToClipboard";
import TransferirCorretorResponsavel from "../TransferirCorretorResponsavel/TransferirCorretorResponsavel";
import { useForm } from "react-hook-form";
import "./styles.css";
import TransferirOportunidadesEmMassa from "./TransferirLeadsEmMassa/TransferirLeadsEmMassa";
import EditarLead from "./PesoLeads/EditarLeads/EditarLeads";
import HistoricoWhatsapp from "../../../Components/CardsPages/Atendimento/AtendimentoDetalhado/AcoesInteracao/HistoricoWhatsapp/HistoricoWhatsapp";
import { useUserInfor } from "../../../Context/User";
import ExportExcel from "../../../Components/StickyToolbar/ExportExcel";
import DragAndDropLeads from "./DragAndDropLeads/DragAndDropLeads";
import SpinnerComponent from "../../../Components/Loding/Spinner";

export default function GestaoLeads() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [modalCloseHistorico, setModalCloseHistorico] = useState(false);

    const FormMethods = useForm();

    const [idEmpreendimento, setIdEmpreendimento] = useState<string>();
    const [idPesoAtendimento, setIdPesoAtendimento] = useState<string>();
    const [isDragAndDrop, setIsDragAndDrop] = useState(
        localStorage.getItem("isDragAndDrop") === "true" ? true : false
    );
    const toggleView = () => {
        setIsDragAndDrop((prev) => !prev);
        setPage(1);
        setFilter(filtroInicial);
        localStorage.setItem("isDragAndDrop", (!isDragAndDrop).toString());
    };

    const FILTRO_GESTAO_LEADS_VENDAS = sessionStorage.getItem(
        "FILTRO_GESTAO_LEADS_VENDAS"
    );

    const { id } = useModuloInfo();

    const { getConfigGeralVendas } = useUserInfor();

    const dataVazia = getConfigGeralVendas?.find(
        (config) =>
            config.DS_OBSERVACAO ===
            "Habilita o filtro inicial na tela de Solicitações"
    )?.VL_CONFIGURACAO;

    const filtroInicial: IListarCasoRequest = {
        NR_PAGINA: 1,
        NR_QUANTIDADE: 10,
        DS_PESQUISA: "",
        DS_EMAIL: "",
        DS_NOME_CONTA: "",
        DS_SITUACAO: "Em Andamento",
        DT_FIM: dataVazia === "1" ? "" : moment().format("YYYY-MM-DD"),
        DT_INICIO:
            dataVazia === "1"
                ? ""
                : moment().subtract(3, "months").format("YYYY-MM-DD"),
        FL_ASSINATURA_CONCLUIDA: undefined,
        FL_ENVELOPE_ENVIADO: undefined,
        ID_CASO: 0,
        ID_CONTRATO_STATUS: 0,
        ID_EQUIPE_VENDAS: "",
        FILTRO_DATA: 1,
        ID_ETAPA_TIPO_CASO: 0,
        ID_ORIGEM_LEAD: "",
        ID_PRODUTO: "",
        ID_USUARIO_CADASTRO: 0,
        ID_USUARIO_RESPONSAVEL: 0,
        NR_CPF: "",
        NR_DIAS_ESTAGNADO_MAX: 0,
        NR_DIAS_ESTAGNADO_MIN: 0,
        NR_OPORTUNIDADE: "" as any,
        NR_TELEFONE: "",
        DT_VENCIMENTO_FN: 0,
        DT_VENCIMENTO_IN: 0,
        FL_VENCIDO: undefined,
        ID_TIPO_PESO_ATENDIMENTO: undefined,
    };

    const { PageFilter, setPage, filter, setFilter, page } =
        usePaginationFilter<IListarCasoRequest>({
            page: 1,
            filter: FILTRO_GESTAO_LEADS_VENDAS
                ? JSON.parse(FILTRO_GESTAO_LEADS_VENDAS)
                : filtroInicial,
        });

    const handleFilter = (formData: any) => {
        console.log("formData", formData);
        const filterFormData = { ...formData };
        PageFilter.page = 1;
        setFilter(filterFormData);
        sessionStorage.setItem(
            "FILTRO_GESTAO_LEADS_VENDAS",
            JSON.stringify(filterFormData)
        );
    };

    const {
        value: lstEtapasVendas,
        loading: lstEtapasVendasLoading,
        execute: executeListarEtapasVendas,
    } = useAsyncEffect(async () => {
        return ListarEtapasVendasController();
    }, []);

    const {
        value: lstCasos,
        loading: lstCasosLoading,
        execute: updateList,
    } = useAsyncEffect(
        () =>
            ListarCasosVendasController({
                ...filter,
                NR_PAGINA: page,
                NR_QUANTIDADE: isDragAndDrop ? 1000 : 10,
                DS_PESQUISA: filter?.DS_PESQUISA ? filter?.DS_PESQUISA : "",
                DS_EMAIL: filter?.DS_EMAIL ? filter?.DS_EMAIL : "",
                DS_NOME_CONTA: filter?.DS_NOME_CONTA
                    ? filter?.DS_NOME_CONTA
                    : "",
                DS_SITUACAO: filter?.DS_SITUACAO ? filter?.DS_SITUACAO : "",
                DT_FIM: filter?.DT_FIM ? filter?.DT_FIM : undefined,
                DT_INICIO: filter?.DT_INICIO ? filter?.DT_INICIO : undefined,
                FL_ASSINATURA_CONCLUIDA: filter?.FL_ASSINATURA_CONCLUIDA
                    ? filter?.FL_ASSINATURA_CONCLUIDA
                    : undefined,
                FL_ENVELOPE_ENVIADO: filter?.FL_ENVELOPE_ENVIADO
                    ? filter?.FL_ENVELOPE_ENVIADO
                    : undefined,
                ID_CASO: filter?.ID_CASO ? filter?.ID_CASO : 0,
                ID_CONTRATO_STATUS: filter?.ID_CONTRATO_STATUS
                    ? filter?.ID_CONTRATO_STATUS
                    : 0,
                ID_EQUIPE_VENDAS: filter?.ID_EQUIPE_VENDAS
                    ? filter?.ID_EQUIPE_VENDAS
                    : "",
                FILTRO_DATA: filter?.FILTRO_DATA ? filter?.FILTRO_DATA : 1,
                ID_ETAPA_TIPO_CASO: filter?.ID_ETAPA_TIPO_CASO
                    ? filter?.ID_ETAPA_TIPO_CASO
                    : 0,
                ID_ORIGEM_LEAD: filter?.ID_ORIGEM_LEAD
                    ? filter?.ID_ORIGEM_LEAD
                    : "",
                ID_PRODUTO: idEmpreendimento ? idEmpreendimento : "",
                ID_USUARIO_CADASTRO: filter?.ID_USUARIO_CADASTRO
                    ? filter?.ID_USUARIO_CADASTRO
                    : 0,
                ID_USUARIO_RESPONSAVEL: filter?.ID_USUARIO_RESPONSAVEL
                    ? filter?.ID_USUARIO_RESPONSAVEL
                    : 0,
                NR_CPF: filter?.NR_CPF ? filter?.NR_CPF : "",
                NR_DIAS_ESTAGNADO_MAX: filter?.NR_DIAS_ESTAGNADO_MAX
                    ? filter?.NR_DIAS_ESTAGNADO_MAX
                    : 0,
                NR_DIAS_ESTAGNADO_MIN: filter?.NR_DIAS_ESTAGNADO_MIN
                    ? filter?.NR_DIAS_ESTAGNADO_MIN
                    : 0,
                NR_OPORTUNIDADE: filter?.NR_OPORTUNIDADE
                    ? filter?.NR_OPORTUNIDADE
                    : 0,
                NR_TELEFONE: filter?.NR_TELEFONE ? filter?.NR_TELEFONE : "",
                DT_VENCIMENTO_FN: filter?.DT_VENCIMENTO_FN
                    ? Number(filter?.DT_VENCIMENTO_FN)
                    : undefined,
                DT_VENCIMENTO_IN: filter?.DT_VENCIMENTO_IN
                    ? Number(filter?.DT_VENCIMENTO_IN)
                    : undefined,
                FL_VENCIDO:
                    filter?.FL_VENCIDO === "Sim"
                        ? true
                        : filter?.FL_VENCIDO === "Não"
                        ? false
                        : undefined,
                ID_TIPO_PESO_ATENDIMENTO: idPesoAtendimento
                    ? idPesoAtendimento
                    : "",
            }),
        [page, id, filter]
    );

    const totalPaginas = lstCasos?.[0]?.NR_PAGINAS || 1;

    function extractTextFromHTML(htmlString: string) {
        const tempElement = document.createElement("div");

        tempElement.innerHTML = htmlString ?? "";

        return tempElement.textContent || tempElement.innerText || "";
    }

    function ClientesRow(props: {
        row: IListarCasoResponse;
        setShow: Dispatch<SetStateAction<boolean>>;
        setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
    }) {
        const caso = props.row;

        const linkAtendimento = ACESSOS.VENDAS.TELAS.ATENDIMENTO.DS_LINK;

        const dataAtual = moment();
        const dataUltimaInteracao = moment(caso.DT_ULTIMA_INTERACAO);
        const diffDias = dataAtual.diff(dataUltimaInteracao, "days");

        const dtVencimentoLead = dataUltimaInteracao.add(
            caso.DT_DIAS_VENCIMENTO,
            "days"
        );

        let corClasseUltimaInteracao = "";
        if (diffDias <= 2) {
            corClasseUltimaInteracao = "success";
        } else if (diffDias <= 5) {
            corClasseUltimaInteracao = "warning";
        } else {
            corClasseUltimaInteracao = "danger";
        }

        const diasVencimentoLead = dtVencimentoLead.diff(dataAtual, "days");

        let corClasseVencimentoLead = "success";
        let vencidoText = `Vencimento em ${Math.abs(diasVencimentoLead)} dias`;

        if (diasVencimentoLead <= 0) {
            corClasseVencimentoLead = "danger";
            vencidoText = `Vencido a ${Math.abs(diasVencimentoLead)} dias`;
        } else if (diasVencimentoLead <= 10) {
            corClasseVencimentoLead = "warning";
            vencidoText = `Vencimento em ${diasVencimentoLead} dia${
                diasVencimentoLead > 1 ? "s" : ""
            }`;
        }

        let variant = "success";

        const percentual = caso.NR_PROBABILIDADE_FECHAMENTO * 100 || 0;

        if (percentual < 50) {
            variant = "primary";
        } else if (percentual >= 50 && percentual < 80) {
            variant = "warning";
        } else if (percentual >= 80) {
            variant = "danger";
        }

        const isValidTask =
            caso.NR_TAREFAS_PENDENTES > 0
                ? "danger"
                : caso.NR_TAREFAS_PENDENTES === 0 &&
                  caso.NR_TAREFAS_AGENDADAS > 0
                ? "success"
                : "warning";

        const historicoSemHTML = extractTextFromHTML(caso.DS_HISTORICO);

        function getContrastColor(hex: string) {
            if (hex) {
                const color = hex.replace("#", "");

                const r = parseInt(color.substring(0, 2), 16);
                const g = parseInt(color.substring(2, 4), 16);
                const b = parseInt(color.substring(4, 6), 16);

                const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

                return luminance > 0.5 ? "#000000" : "#FFFFFF";
            }
            return "#000000";
        }

        return (
            <div className="card card-custom mb-2 cliente-card icon-background">
                <i
                    style={{
                        color: caso.HX_COR_PESO_ATENDIMENTO,
                        zIndex: 0,
                    }}
                    className={`z-1 ${caso.DS_ICON}`}
                ></i>
                <div className="flex-wrap ribbon ribbon-top ribbon-ver ribbon">
                    <div className="ribbon-target-mult d-none d-sm-flex mr-5">
                        {caso.DS_TIPO_PESO_ATENDIMENTO && (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        {"Peso"}
                                    </Tooltip>
                                }
                            >
                                <div
                                    className={`ribbon-target ribbonCustom`}
                                    style={{
                                        top: "-2px",
                                        backgroundColor:
                                            caso.HX_COR_PESO_ATENDIMENTO,
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <span
                                            className="mt-1"
                                            style={{
                                                color: getContrastColor(
                                                    caso.HX_COR_PESO_ATENDIMENTO
                                                ),
                                            }}
                                        >
                                            {caso.DS_TIPO_PESO_ATENDIMENTO}
                                        </span>
                                    </div>
                                </div>
                            </OverlayTrigger>
                        )}
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="tooltip-disabled">
                                    {"Andamento da oportunidade"}
                                </Tooltip>
                            }
                        >
                            <div
                                className={`ribbon-target ribbonCustom bg-${
                                    caso.DT_FIM ? "danger" : "success"
                                }`}
                                style={{ top: "-2px" }}
                            >
                                {caso.DT_FIM ? "Finalizado" : "Em andamento"}
                            </div>
                        </OverlayTrigger>

                        <OverlayTrigger
                            overlay={
                                <Tooltip id="tooltip-disabled">
                                    ID Oportunidade / Caso
                                </Tooltip>
                            }
                        >
                            <div
                                className="ribbon-target ribbonCustom"
                                style={{
                                    top: "-2px",
                                    backgroundColor: "var(--Vendas)",
                                }}
                            >
                                {caso.ID_CASO}
                            </div>
                        </OverlayTrigger>

                        {/* <div className="ribbonCustom alert-pulse"></div> */}
                    </div>
                </div>
                <div className="card-body">
                    <div className="d-flex mb-6">
                        <div className="flex-grow-1">
                            <div className="d-flex justify-content-between flex-wrap mt-1">
                                <div>
                                    <div>
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="tooltip-disabled">
                                                    Clique para Atender
                                                </Tooltip>
                                            }
                                        >
                                            <Link
                                                to={linkAtendimento(
                                                    caso.ID_CASO
                                                )}
                                                className="text-dark text-hover-primary font-size-h2 font-weight-bold mr-3"
                                            >
                                                {caso.DS_CONTA}
                                            </Link>
                                        </OverlayTrigger>
                                        <span>
                                            <i className="flaticon2-correct text-success font-size-h5"></i>
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <FontAwesomeIcon
                                            icon={faThermometerHalf}
                                            className={`text-${variant} mr-2`}
                                            size="lg"
                                        />
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="tooltip-disabled">
                                                    {"Probabilidade de fechamento: " +
                                                        percentual +
                                                        "%"}
                                                </Tooltip>
                                            }
                                        >
                                            <ProgressBar
                                                variant={variant}
                                                now={percentual}
                                                label={`${percentual}%`}
                                                className="progress-xl w-100"
                                            />
                                        </OverlayTrigger>
                                    </div>
                                </div>

                                {/* <div className="my-lg-0 my-3">
                                    <span
                                        className={`btn btn-sm btn-light-${
                                            caso.DT_FIM ? "danger" : "success"
                                        } font-weight-bolder text-uppercase mr-3`}
                                    >
                                        {caso.DT_FIM
                                            ? "Finalizado"
                                            : "Em andamento"}
                                    </span>
                                    <span
                                        className="btn btn-sm font-weight-bolder text-uppercase"
                                        style={{
                                            backgroundColor: "var(--Vendas)",
                                        }}
                                    >
                                        {caso.ID_CASO}
                                    </span>
                                </div> */}
                            </div>

                            <div className="d-flex flex-wrap justify-content-between mt-1">
                                <div className="d-flex justify-content-between flex-column flex-grow-1 pr-8">
                                    <div className="d-flex flex-wrap mb-4">
                                        {caso.DS_EMAIL && (
                                            <span className="text-dark-50 text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                                <i className="flaticon2-new-email mr-2 font-size-lg"></i>
                                                {caso.DS_EMAIL}
                                                <CopyToClipboard className="mx-2">
                                                    {caso.DS_EMAIL}
                                                </CopyToClipboard>
                                            </span>
                                        )}
                                        {caso.NR_TELEFONE && (
                                            <span className="text-dark-50 text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                                <i className="flaticon2-phone mr-2 font-size-lg"></i>
                                                {formatedTelefone(
                                                    caso.NR_TELEFONE
                                                )}
                                                <CopyToClipboard className="mx-2">
                                                    {formatedTelefone(
                                                        caso.NR_TELEFONE
                                                    )}
                                                </CopyToClipboard>
                                            </span>
                                        )}
                                        {/* <span className="text-dark-50 text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                                            <i className="flaticon2-calendar-3 mr-2 font-size-lg"></i>
                                            PR Manager{" "}
                                        </span>
                                        <span className="text-dark-50 text-hover-primary font-weight-bold">
                                            <i className="flaticon2-placeholder mr-2 font-size-lg"></i>
                                            Melbourne
                                        </span> */}
                                    </div>

                                    <div className="d-flex align-items-center flex-lg-fill mb-2">
                                        <span className="mr-4">
                                            <i className="flaticon2-calendar-3 display-4 text-muted font-weight-bold"></i>
                                        </span>
                                        <div className="d-flex flex-column text-dark-75">
                                            <span className="font-weight-bolder font-size-sm">
                                                Corretor Responsável
                                            </span>
                                            <span className="font-weight-bolder font-size-h6">
                                                {caso.DS_USUARIO_PROPRIETARIO}
                                                {caso.DS_EQUIPE_VENDAS
                                                    ? ` - ${caso.DS_EQUIPE_VENDAS}`
                                                    : ""}{" "}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center flex-lg-fill my-2">
                                        <span className="mr-4">
                                            <FontAwesomeIcon
                                                icon={faGlobe}
                                                className="flaticon2-calendar-3 display-4 text-primary font-weight-bold"
                                            />
                                        </span>
                                        <div className="d-flex flex-column text-dark-75">
                                            <span className="font-weight-bolder font-size-sm">
                                                Origem do Lead
                                            </span>
                                            <span className="font-weight-bolder font-size-h6">
                                                {caso.DS_ORIGEM_LEAD_COMP}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="d-flex mt-2">
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="historico-tooltip">
                                                    Novo Histórico
                                                </Tooltip>
                                            }
                                            placement="bottom"
                                        >
                                            <button
                                                className="btn btn-sm btn-icon btn-light-success mr-2 icon-xl"
                                                onClick={() => {
                                                    setModalCloseHistorico(
                                                        true
                                                    );
                                                    setShow(true);
                                                    setModal({
                                                        headerComponent:
                                                            "Cadastrar Histórico",
                                                        IconHeader:
                                                            faCommentDots,
                                                        Component: () => (
                                                            <CadastrarHistorico
                                                                setShow={
                                                                    setShow
                                                                }
                                                                caso={caso}
                                                                updateList={
                                                                    updateList
                                                                }
                                                            />
                                                        ),
                                                        noFooter: true,
                                                        size: "lg",
                                                    });
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faPlus}
                                                />
                                            </button>
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="historico-tooltip">
                                                    Enviar Email
                                                </Tooltip>
                                            }
                                            placement="bottom"
                                        >
                                            <button
                                                className="btn btn-sm btn-icon btn-light-success mr-2 icon-xl"
                                                onClick={() => {
                                                    setShow(true);
                                                    setModal({
                                                        headerComponent:
                                                            "Enviar Email",
                                                        IconHeader: faEnvelope,
                                                        Component: () => (
                                                            <EnviarEmail
                                                                ID_CASO={
                                                                    caso.ID_CASO
                                                                }
                                                                ID_CONTA={
                                                                    caso.ID_CONTA
                                                                }
                                                                ID_CONTATO={0}
                                                                setShow={
                                                                    setShow
                                                                }
                                                                updateList={
                                                                    updateList
                                                                }
                                                            />
                                                        ),
                                                        scrollable: true,
                                                        size: "xl",
                                                    });
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faEnvelope}
                                                />
                                            </button>
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="cadastrar-atividade-tooltip">
                                                    Cadastrar Atividade
                                                </Tooltip>
                                            }
                                            placement="bottom"
                                        >
                                            <button
                                                className="btn btn-sm btn-icon btn-light-primary mr-2 icon-xl"
                                                type="button"
                                                onClick={() => {
                                                    setShow(true);
                                                    setModal({
                                                        headerComponent:
                                                            "Cadastrar Atividade",
                                                        IconHeader:
                                                            faCheckSquare,
                                                        Component: () => (
                                                            <CasoAtividade
                                                                setShow={
                                                                    setShow
                                                                }
                                                                idCaso={
                                                                    caso.ID_CASO
                                                                }
                                                                updateList={
                                                                    updateList
                                                                }
                                                            />
                                                        ),
                                                        size: "lg",
                                                    });
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faCheckSquare}
                                                />
                                            </button>
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="telefone-tooltip">
                                                    {caso.NR_TELEFONE
                                                        ? "Enviar Mensagem"
                                                        : "Sem telefone cadastrado"}
                                                </Tooltip>
                                            }
                                            placement="bottom"
                                        >
                                            <button
                                                className="btn btn-sm btn-icon btn-light-success mr-2 icon-xl"
                                                onClick={() => {
                                                    setShow(true);
                                                    setModal({
                                                        headerComponent:
                                                            "Histórico WhatsApp",
                                                        IconHeader: faHistory,
                                                        Component: () => (
                                                            <HistoricoWhatsapp
                                                                setShow={
                                                                    setShow
                                                                }
                                                                updateList={
                                                                    updateList
                                                                }
                                                                caso={caso}
                                                            />
                                                        ),
                                                        scrollable: true,
                                                        size: "xl",
                                                    });
                                                }}
                                                disabled={!caso.NR_TELEFONE}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faWhatsapp}
                                                />
                                            </button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="cadastrar-visita-tooltip">
                                                    Cadastrar Visita
                                                </Tooltip>
                                            }
                                            placement="bottom"
                                        >
                                            <button
                                                className="btn btn-sm btn-icon btn-light-primary mr-2 icon-xl"
                                                onClick={() => {
                                                    setShow(true);
                                                    setModal({
                                                        headerComponent:
                                                            "Cadastrar Visita",
                                                        IconHeader: faHome,
                                                        Component: () => (
                                                            <CadastrarVisita
                                                                setShow={
                                                                    setShow
                                                                }
                                                                caso={caso}
                                                                updateList={
                                                                    updateList
                                                                }
                                                            />
                                                        ),
                                                        size: "lg",
                                                    });
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faHome}
                                                />
                                            </button>
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="transferir-tooltip">
                                                    Transferir Corretor
                                                </Tooltip>
                                            }
                                            placement="bottom"
                                        >
                                            <button
                                                className="btn btn-sm btn-icon btn-light-warning mr-2 icon-xl"
                                                onClick={() => {
                                                    setModal({
                                                        Component: () => (
                                                            <TransferirCorretorResponsavel
                                                                idCorretorResponsavel={
                                                                    caso.ID_USUARIO_RESPONSAVEL
                                                                }
                                                                updateList={
                                                                    updateList
                                                                }
                                                                ID_CASO={
                                                                    caso.ID_CASO
                                                                }
                                                                setShow={
                                                                    setShow
                                                                }
                                                            />
                                                        ),
                                                        IconHeader:
                                                            faExchangeAlt,
                                                        headerComponent:
                                                            "Transferir Corretor",
                                                    });
                                                    setShow(true);
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faExchangeAlt}
                                                />
                                            </button>
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="edit-peso-tooltip">
                                                    Editar Dados da Oportunidade
                                                </Tooltip>
                                            }
                                            placement="bottom"
                                        >
                                            <button
                                                className="btn btn-sm btn-icon btn-light-primary mr-2 icon-xl"
                                                onClick={() => {
                                                    setModal({
                                                        Component: () => (
                                                            <EditarLead
                                                                updateList={
                                                                    updateList
                                                                }
                                                                setShow={
                                                                    setShow
                                                                }
                                                                caso={caso}
                                                            />
                                                        ),
                                                        IconHeader: faEdit,
                                                        collapseForm: false,
                                                        size: "lg",
                                                        headerComponent:
                                                            "Editar Dados da Oportunidade",
                                                    });
                                                    setShow(true);
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faEdit}
                                                />
                                            </button>
                                        </OverlayTrigger>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-center align-items-end w-25 flex-fill flex-column">
                                    <div className="d-flex flex-wrap mb-3">
                                        <div className="d-flex flex-column mr-6">
                                            <div className="font-weight-bold mb-2">
                                                Data de início
                                            </div>
                                            <span className="btn btn-sm btn-text btn-light-primary text-uppercase font-weight-bold">
                                                {moment(caso.DT_INICIO).format(
                                                    "DD/MM/YYYY - HH:mm"
                                                )}
                                            </span>
                                            <strong className="text-primary">
                                                Aberto a{" "}
                                                {caso.NR_DIAS_ABERTO === 0
                                                    ? "menos de 1"
                                                    : caso.NR_DIAS_ABERTO}{" "}
                                                dia
                                                {caso.NR_DIAS_ABERTO > 1
                                                    ? "s"
                                                    : ""}
                                            </strong>
                                        </div>

                                        {caso.DT_ULTIMA_INTERACAO && (
                                            <div className="d-flex flex-column mr-6">
                                                <div className="font-weight-bold mb-2">
                                                    Última Interação
                                                </div>

                                                <span
                                                    className={`btn btn-sm btn-text btn-light-${corClasseUltimaInteracao} text-uppercase font-weight-bold`}
                                                >
                                                    {moment(
                                                        caso.DT_ULTIMA_INTERACAO
                                                    ).format(
                                                        "DD/MM/YYYY - HH:mm"
                                                    )}
                                                </span>

                                                {caso.DT_ULTIMA_INTERACAO && (
                                                    <>
                                                        <strong
                                                            className={`text-${corClasseUltimaInteracao}`}
                                                        >
                                                            Sem Interação a{" "}
                                                            {caso.NR_DIAS_SEM_INTERACAO ===
                                                            0
                                                                ? "menos de 1"
                                                                : caso.NR_DIAS_SEM_INTERACAO}{" "}
                                                            dia
                                                            {caso.NR_DIAS_SEM_INTERACAO >
                                                            1
                                                                ? "s"
                                                                : ""}
                                                        </strong>
                                                    </>
                                                )}
                                            </div>
                                        )}

                                        <div className="d-flex flex-column mr-6">
                                            <div className="font-weight-bold mb-2">
                                                Data Vencimento do Lead
                                            </div>
                                            <span
                                                className={`btn btn-sm btn-text btn-light-${corClasseVencimentoLead} text-uppercase font-weight-bold`}
                                            >
                                                {dtVencimentoLead.format(
                                                    "DD/MM/YYYY - HH:mm"
                                                )}
                                            </span>
                                            <strong
                                                className={`text-${corClasseVencimentoLead}`}
                                            >
                                                {vencidoText}
                                            </strong>
                                        </div>

                                        {caso.DT_FIM && (
                                            <div className="d-flex flex-column mr-6">
                                                <div className="font-weight-bold mb-2">
                                                    Data de Encerramento
                                                </div>
                                                <span className="btn btn-sm btn-text btn-light-danger text-uppercase font-weight-bold">
                                                    {moment(caso.DT_FIM).format(
                                                        "DD/MM/YYYY - HH:mm"
                                                    )}
                                                </span>
                                            </div>
                                        )}
                                    </div>

                                    <div className="d-flex">
                                        <div className="d-flex flex-column mr-6">
                                            <div className="font-weight-bold mb-2">
                                                Expectativa de fechamento
                                            </div>
                                            <span className="btn btn-sm btn-text btn-light-primary text-uppercase font-weight-bold">
                                                {moment(
                                                    caso.DT_EXPECTATIVA_FECHAMENTO
                                                ).format("DD/MM/YYYY")}
                                            </span>
                                        </div>

                                        <div className="d-flex flex-column mr-6">
                                            <div className="font-weight-bold mb-2">
                                                Valor da oportunidade
                                            </div>
                                            <span className="btn btn-sm btn-text btn-light-success text-uppercase font-weight-bold">
                                                {formatMoneyReais(
                                                    caso.VL_OPORTUNIDADE
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="separator separator-solid"></div>

                    <div className="d-flex align-items-center flex-wrap mt-4">
                        <div
                            className="d-flex align-items-center flex-lg-fill mr-5 mb-2"
                            style={{
                                width: "15%",
                            }}
                        >
                            <span className="mr-4">
                                <FontAwesomeIcon
                                    icon={faFunnelDollar}
                                    size="2x"
                                />
                                {/* <i className="flaticon-pie-chart display-4 text-muted font-weight-bold"></i> */}
                            </span>

                            <div className="d-flex flex-column text-dark-75">
                                <span className="font-weight-bolder font-size-sm">
                                    Etapa Atual
                                </span>
                                <span className="font-weight-bolder font-size-h6">
                                    {caso.DS_ETAPA}
                                </span>
                            </div>
                        </div>

                        <div
                            className="d-flex align-items-center flex-lg-fill mr-5 mb-2"
                            style={{
                                width: "15%",
                            }}
                        >
                            <span className="mr-4">
                                <i className="flaticon-home display-4 text-muted font-weight-bold"></i>
                            </span>
                            <div className="d-flex flex-column text-dark-75">
                                <span className="font-weight-bolder font-size-sm">
                                    Produto de Interesse
                                </span>
                                <span className="font-weight-bolder font-size-h6">
                                    {caso.DS_PRODUTO}
                                </span>
                            </div>
                        </div>

                        <div
                            className="d-flex align-items-center flex-lg-fill mr-5 mb-2"
                            style={{
                                width: "15%",
                            }}
                        >
                            <span className="mr-4">
                                <i className="flaticon-file-2 display-4 text-muted font-weight-bold"></i>
                            </span>
                            <div className="d-flex align-items-start flex-column flex-lg-fill">
                                <span
                                    className={`text-${isValidTask} font-weight-bolder font-size-sm`}
                                >
                                    {caso.NR_TAREFAS_PENDENTES > 0
                                        ? `Atividades Atrasadas: ${caso.NR_TAREFAS_PENDENTES}`
                                        : caso.NR_TAREFAS_PENDENTES === 0 &&
                                          caso.NR_TAREFAS_AGENDADAS > 0
                                        ? `Atividades Planejadas: ${caso.NR_TAREFAS_AGENDADAS}`
                                        : `Sem Atividades Planejadas`}
                                </span>
                                <button className="text-start text-primary font-weight-bolder btn btn-none p-0 m-0">
                                    Visualizar
                                </button>
                            </div>
                        </div>

                        <div
                            className="d-flex align-items-center flex-lg-fill mr-5 mb-2"
                            style={{
                                width: "15%",
                            }}
                        >
                            <span className="mr-4">
                                <i className="flaticon-chat-1 display-4 text-muted font-weight-bold"></i>
                            </span>
                            {/* <div className="d-flex flex-column text-dark-75">
                                <span className="font-weight-bolder font-size-sm">
                                    <strong>Usuário Última Interação:</strong>{" "}
                                    {caso.DS_NOME_USUARIO_INTERACAO}
                                </span>
                                <span className="font-weight-bolder">
                                    <button
                                        className="btn btn-none font-weight-bolder text-primary m-0 p-0"
                                        onClick={() => {
                                            setModal({
                                                Component: () =>
                                                    HistoricoCardPage({
                                                        ID_CASO: caso.ID_CASO,
                                                    }),
                                                headerComponent: "Históricos",
                                                IconHeader: faHistory,
                                                collapseForm: true,
                                                size: "lg",
                                            });
                                            setShow(true);
                                        }}
                                    >
                                        Ver histórico
                                    </button>
                                </span>
                            </div> */}

                            <div className="d-flex flex-column align-itens-center justify-content-start text-align-end">
                                <label className="mt-2">
                                    <strong>Ultima Interação</strong>:{" "}
                                    {caso.DT_ULTIMA_INTERACAO ? (
                                        <>
                                            {moment(
                                                caso.DT_ULTIMA_INTERACAO
                                            ).format("DD-MM-YYYY HH:mm")}{" "}
                                        </>
                                    ) : (
                                        "-"
                                    )}
                                </label>

                                <p className="m-0 z-1">
                                    {historicoSemHTML.length > 0 && (
                                        <>
                                            {caso.DS_NOME_USUARIO_INTERACAO} -{" "}
                                            {historicoSemHTML.substring(0, 45)}
                                            ...
                                            <OverlayTrigger
                                                overlay={
                                                    historicoSemHTML.length >
                                                    0 ? (
                                                        <Tooltip id="historico-tooltip">
                                                            {historicoSemHTML}
                                                        </Tooltip>
                                                    ) : (
                                                        <Tooltip id="historico-tooltip">
                                                            Sem histórico
                                                            registrado
                                                        </Tooltip>
                                                    )
                                                }
                                                placement="top"
                                            >
                                                <FontAwesomeIcon
                                                    icon={faSearch}
                                                />
                                            </OverlayTrigger>
                                        </>
                                    )}
                                    <button
                                        className="btn btn-none font-weight-bolder text-primary m-0 p-0"
                                        onClick={() => {
                                            setModal({
                                                Component: () =>
                                                    HistoricoCardPage({
                                                        ID_CASO: caso.ID_CASO,
                                                    }),
                                                headerComponent: "Históricos",
                                                IconHeader: faHistory,
                                                collapseForm: true,
                                                size: "lg",
                                            });
                                            setShow(true);
                                        }}
                                    >
                                        Ver histórico
                                    </button>
                                </p>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end align-items-center flex-lg-fill mb-2 float-left">
                            <Link
                                to={ACESSOS.VENDAS.TELAS.ATENDIMENTO.DS_LINK(
                                    caso.ID_CASO || 0
                                )}
                                type="button"
                                className="d-flex btn btn-outline-primary btn-sm text-uppercase font-weight-bolder mt-5 z-1"
                            >
                                <i className="flaticon2-pen "></i> Atender
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const columns: Array<ColumnDescription<IListarCasoResponse>> = [
        {
            dataField: "ID_CONTA",
            text: "",
            formatter: (c, row) => (
                <ClientesRow row={row} setModal={setModal} setShow={setShow} />
            ),
        },
    ];

    const ultimaPesquisaRef = useRef("");
    const [pesquisaText, setPesquisaText] = useState("");

    function handleSearch(searchValue: string, newState: IPropsTableChange) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                setFilter({
                    ...filter,
                    DS_PESQUISA: newState.searchText,
                    NR_PAGINA: page,
                    NR_QUANTIDADE: 10,
                    DS_EMAIL: filter?.DS_EMAIL ? filter?.DS_EMAIL : "",
                    DS_NOME_CONTA: filter?.DS_NOME_CONTA
                        ? filter?.DS_NOME_CONTA
                        : "",
                    DS_SITUACAO: filter?.DS_SITUACAO ? filter?.DS_SITUACAO : "",
                    DT_FIM: filter?.DT_FIM ? filter?.DT_FIM : "",
                    DT_INICIO: filter?.DT_INICIO ? filter?.DT_INICIO : "",
                    FL_ASSINATURA_CONCLUIDA: filter?.FL_ASSINATURA_CONCLUIDA
                        ? filter?.FL_ASSINATURA_CONCLUIDA
                        : undefined,
                    FL_ENVELOPE_ENVIADO: filter?.FL_ENVELOPE_ENVIADO
                        ? filter?.FL_ENVELOPE_ENVIADO
                        : undefined,
                    ID_CASO: filter?.ID_CASO ? filter?.ID_CASO : 0,
                    ID_CONTRATO_STATUS: filter?.ID_CONTRATO_STATUS
                        ? filter?.ID_CONTRATO_STATUS
                        : 0,
                    ID_EQUIPE_VENDAS: filter?.ID_EQUIPE_VENDAS
                        ? filter?.ID_EQUIPE_VENDAS
                        : "",
                    FILTRO_DATA: filter?.FILTRO_DATA ? filter?.FILTRO_DATA : 0,
                    ID_ETAPA_TIPO_CASO: filter?.ID_ETAPA_TIPO_CASO
                        ? filter?.ID_ETAPA_TIPO_CASO
                        : 0,
                    ID_ORIGEM_LEAD: filter?.ID_ORIGEM_LEAD
                        ? filter?.ID_ORIGEM_LEAD
                        : "",
                    ID_PRODUTO: idEmpreendimento ? idEmpreendimento : "",
                    ID_USUARIO_CADASTRO: filter?.ID_USUARIO_CADASTRO
                        ? filter?.ID_USUARIO_CADASTRO
                        : 0,
                    ID_USUARIO_RESPONSAVEL: filter?.ID_USUARIO_RESPONSAVEL
                        ? filter?.ID_USUARIO_RESPONSAVEL
                        : 0,
                    NR_CPF: filter?.NR_CPF ? filter?.NR_CPF : "",
                    NR_DIAS_ESTAGNADO_MAX: filter?.NR_DIAS_ESTAGNADO_MAX
                        ? filter?.NR_DIAS_ESTAGNADO_MAX
                        : 0,
                    NR_DIAS_ESTAGNADO_MIN: filter?.NR_DIAS_ESTAGNADO_MIN
                        ? filter?.NR_DIAS_ESTAGNADO_MIN
                        : 0,
                    NR_OPORTUNIDADE: filter?.NR_OPORTUNIDADE
                        ? filter?.NR_OPORTUNIDADE
                        : 0,
                    NR_TELEFONE: filter?.NR_TELEFONE ? filter?.NR_TELEFONE : "",
                    ID_TIPO_PESO_ATENDIMENTO: idPesoAtendimento
                        ? idPesoAtendimento
                        : "",
                });
                setPage(newState.page);
            }
        }, 1500);
    }

    return (
        <div className="card card-custom">
            <div className="d-flex justify-content-end p-4">
                <Button variant="primary" onClick={toggleView}>
                    <FontAwesomeIcon
                        icon={isDragAndDrop ? faBars : faFunnelDollar}
                    />{" "}
                    {isDragAndDrop ? "Visão Tabela" : "Visão Funil"}
                </Button>
            </div>
            {lstCasosLoading ? (
                <></>
            ) : (
                <div className="d-flex flex-row px-4 pt-4 justify-content-around">
                    <div className="col">
                        <div className="d-flex align-items-center mr-2">
                            <div className="symbol symbol-45 symbol-light-info mr-4 flex-shrink-0">
                                <div className="symbol-label">
                                    <span className="svg-icon svg-icon-lg svg-icon-info">
                                        <FontAwesomeIcon icon={faChartBar} />
                                    </span>{" "}
                                </div>
                            </div>

                            <div>
                                <div className="font-size-h4 text-dark-75 font-weight-bolder">
                                    Oportunidades do Corretor
                                </div>
                                <div className="font-size-lg text-muted font-weight-bold mt-1">
                                    {lstCasos?.[0]?.TOTAL_LEADS_USUARIO ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="d-flex align-items-center mr-2">
                            <div className="symbol symbol-45 symbol-light-info mr-4 flex-shrink-0">
                                <div className="symbol-label">
                                    <span className="svg-icon svg-icon-lg svg-icon-info">
                                        <FontAwesomeIcon icon={faCircle} />
                                    </span>{" "}
                                </div>
                            </div>

                            <div>
                                <div className="font-size-h4 text-dark-75 font-weight-bolder">
                                    Oportunidades da Equipe
                                </div>
                                <div className="font-size-lg text-muted font-weight-bold mt-1">
                                    {lstCasos?.[0]?.TOTAL_LEADS_EQUIPE ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="d-flex align-items-center mr-2">
                            <div className="symbol symbol-45 symbol-light-info mr-4 flex-shrink-0">
                                <div className="symbol-label">
                                    <span className="svg-icon svg-icon-lg svg-icon-info">
                                        <FontAwesomeIcon icon={faHashtag} />
                                    </span>{" "}
                                </div>
                            </div>

                            <div>
                                <div className="font-size-h4 text-dark-75 font-weight-bolder">
                                    Oportunidades Geral
                                </div>
                                <div className="font-size-lg text-muted font-weight-bold mt-1">
                                    {lstCasos?.[0]?.TOTAL_LEADS_GERAL ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="d-flex align-items-center mr-2">
                            <div className="symbol symbol-45 symbol-light-info mr-4 flex-shrink-0">
                                <div className="symbol-label">
                                    <span className="svg-icon svg-icon-lg svg-icon-info">
                                        <FontAwesomeIcon icon={faChartBar} />
                                    </span>{" "}
                                </div>
                            </div>

                            <div>
                                <div className="font-size-h4 text-dark-75 font-weight-bolder">
                                    Oportunidades Vencidas
                                </div>
                                <div className="font-size-lg text-muted font-weight-bold mt-1">
                                    {lstCasos?.[0]?.TOTAL_LEADS_VENCIDOS ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {!isDragAndDrop ? (
                <>
                    <div className="cardsTable mt-3 p-3">
                        <Table
                            data={lstCasos ?? []}
                            columns={columns}
                            keyField="ID_CONTA"
                            loading={lstCasosLoading}
                            onTableChange={(_type, newState) => {
                                const state = newState as IPropsTableChange;

                                if (state.searchText !== "") {
                                    handleSearch(state.searchText, state);
                                    setPesquisaText(state.searchText);
                                } else if (pesquisaText.length > 0) {
                                    setFilter({
                                        DS_PESQUISA: state.searchText,
                                        NR_PAGINA: PageFilter.page,
                                        NR_QUANTIDADE: 10,
                                        DT_FIM: filter?.DT_FIM,
                                        DT_INICIO: filter?.DT_INICIO,
                                        DT_VENCIMENTO_FN:
                                            filter?.DT_VENCIMENTO_FN,
                                        DT_VENCIMENTO_IN:
                                            filter?.DT_VENCIMENTO_IN,
                                    });
                                } else {
                                    setPage(state.page);
                                }
                            }}
                            remote={{ pagination: true }}
                            totalPages={totalPaginas}
                        />
                    </div>
                </>
            ) : (
                <div className="drag-and-drop mt-3 p-3">
                    {lstEtapasVendasLoading ? (
                        <SpinnerComponent />
                    ) : (
                        <>
                            <DragAndDropLeads
                                lstEtapasVendas={lstEtapasVendas ?? []}
                                lstCasos={lstCasos ?? []}
                                lstCasosLoading={lstCasosLoading}
                                handleSearch={handleSearch}
                                setPesquisaText={setPesquisaText}
                                setFilter={setFilter}
                                setPage={setPage}
                                totalPaginas={totalPaginas}
                                pesquisaText={pesquisaText}
                                filter={filter}
                                PageFilter={PageFilter}
                                updateList={updateList}
                                executeListarEtapasVendas={
                                    executeListarEtapasVendas
                                }
                            />
                        </>
                    )}
                </div>
            )}
            <StickyToolbar
                Filters={
                    <FilterGestaoLeads
                        handleFilter={handleFilter}
                        lstCasosLoading={lstCasosLoading}
                        filter={{
                            ...filter,
                            ID_PRODUTO: idEmpreendimento,
                            NR_PAGINA: page,
                            NR_QUANTIDADE: 10,
                        }}
                        setIdEmpreendimento={setIdEmpreendimento}
                        setIdPesoAtendimento={setIdPesoAtendimento}
                        filtroInicial={filtroInicial}
                        FormMethods={FormMethods}
                    />
                }
                active={!!FILTRO_GESTAO_LEADS_VENDAS}
            />
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
                modalClose={modalCloseHistorico}
                setModalClose={setModalCloseHistorico}
            />
            <TransferirOportunidadesEmMassa
                setShow={setShow}
                updateList={updateList}
                filter={PageFilter}
                idEmpreendimento={idEmpreendimento}
            />
            <ExportExcel
                baixarExcelController={async () =>
                    ExportarExcelCasosVendasController({
                        ...filter,
                        NR_PAGINA: 0,
                        NR_QUANTIDADE: 0,
                        DS_PESQUISA: filter?.DS_PESQUISA
                            ? filter?.DS_PESQUISA
                            : "",
                        DS_EMAIL: filter?.DS_EMAIL ? filter?.DS_EMAIL : "",
                        DS_NOME_CONTA: filter?.DS_NOME_CONTA
                            ? filter?.DS_NOME_CONTA
                            : "",
                        DS_SITUACAO: filter?.DS_SITUACAO
                            ? filter?.DS_SITUACAO
                            : "",
                        DT_FIM: filter?.DT_FIM ? filter?.DT_FIM : undefined,
                        DT_INICIO: filter?.DT_INICIO
                            ? filter?.DT_INICIO
                            : undefined,
                        FL_ASSINATURA_CONCLUIDA: filter?.FL_ASSINATURA_CONCLUIDA
                            ? filter?.FL_ASSINATURA_CONCLUIDA
                            : undefined,
                        FL_ENVELOPE_ENVIADO: filter?.FL_ENVELOPE_ENVIADO
                            ? filter?.FL_ENVELOPE_ENVIADO
                            : undefined,
                        ID_CASO: filter?.ID_CASO ? filter?.ID_CASO : 0,
                        ID_CONTRATO_STATUS: filter?.ID_CONTRATO_STATUS
                            ? filter?.ID_CONTRATO_STATUS
                            : 0,
                        ID_EQUIPE_VENDAS: filter?.ID_EQUIPE_VENDAS
                            ? filter?.ID_EQUIPE_VENDAS
                            : "",
                        FILTRO_DATA: filter?.FILTRO_DATA
                            ? filter?.FILTRO_DATA
                            : 1,
                        ID_ETAPA_TIPO_CASO: filter?.ID_ETAPA_TIPO_CASO
                            ? filter?.ID_ETAPA_TIPO_CASO
                            : 0,
                        ID_ORIGEM_LEAD: filter?.ID_ORIGEM_LEAD
                            ? filter?.ID_ORIGEM_LEAD
                            : "",
                        ID_PRODUTO: idEmpreendimento ? idEmpreendimento : "",
                        ID_USUARIO_CADASTRO: filter?.ID_USUARIO_CADASTRO
                            ? filter?.ID_USUARIO_CADASTRO
                            : 0,
                        ID_USUARIO_RESPONSAVEL: filter?.ID_USUARIO_RESPONSAVEL
                            ? filter?.ID_USUARIO_RESPONSAVEL
                            : 0,
                        NR_CPF: filter?.NR_CPF ? filter?.NR_CPF : "",
                        NR_DIAS_ESTAGNADO_MAX: filter?.NR_DIAS_ESTAGNADO_MAX
                            ? filter?.NR_DIAS_ESTAGNADO_MAX
                            : 0,
                        NR_DIAS_ESTAGNADO_MIN: filter?.NR_DIAS_ESTAGNADO_MIN
                            ? filter?.NR_DIAS_ESTAGNADO_MIN
                            : 0,
                        NR_OPORTUNIDADE: filter?.NR_OPORTUNIDADE
                            ? filter?.NR_OPORTUNIDADE
                            : 0,
                        NR_TELEFONE: filter?.NR_TELEFONE
                            ? filter?.NR_TELEFONE
                            : "",
                        DT_VENCIMENTO_FN: filter?.DT_VENCIMENTO_FN
                            ? Number(filter?.DT_VENCIMENTO_FN)
                            : undefined,
                        DT_VENCIMENTO_IN: filter?.DT_VENCIMENTO_IN
                            ? Number(filter?.DT_VENCIMENTO_IN)
                            : undefined,
                        FL_VENCIDO:
                            filter?.FL_VENCIDO === "Sim"
                                ? true
                                : filter?.FL_VENCIDO === "Não"
                                ? false
                                : undefined,
                        ID_TIPO_PESO_ATENDIMENTO: idPesoAtendimento
                            ? idPesoAtendimento
                            : "",
                    })
                }
                nomeArquivo={`Gestão_Oportunidades`}
            />
        </div>
    );
}
